import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Cookies from 'js-cookie'
import store from './store';
import * as echarts from 'echarts'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;

Vue.use(Element,{
  size: Cookies.get('size') || 'mini', // set element-ui default size
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js